import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const updateMyProfile = (data) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(apiTypes.PUT, apiConstants.PROFILE.UPDATE_MY_PROFILE, data, cancelToken);
};

export default updateMyProfile;
